export const ALL_SENTINEL = '__all__';

/**
 * Next selection after clicking a tab.
 *
 * `allMode` is the "All" tab being checked, which is a distinct state from "every
 * country happens to be checked": both send the same country list downstream, but
 * All shows checked in the first case only. Leaving All by clicking a country
 * therefore narrows the selection down to that country, while clicking a country
 * with every box checked by hand simply unchecks it.
 */
export const toggleCountrySelection = (
  selected: string[],
  allNames: string[],
  clicked: string,
  allMode: boolean = false
): string[] => {
  if (allNames.length === 0) return selected;

  if (clicked === ALL_SENTINEL) {
    return [...allNames];
  }

  if (allMode) {
    return [clicked];
  }

  if (selected.includes(clicked)) {
    return selected.length === 1 ? selected : selected.filter((c) => c !== clicked);
  }

  return [...selected, clicked];
};
